var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-page" },
    [
      _c("div", { staticClass: "contact-section" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-md-12 col-lg-11" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "form_row" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6 brdr-right" }, [
                    _c("div", { staticClass: "form_blk" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "form" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.closetoogleshow4,
                                expression: "closetoogleshow4"
                              }
                            ],
                            staticClass: "filter-blck filter-dropdown"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-full btn-white dropdown",
                                on: {
                                  click: function($event) {
                                    _vm.show4 = !_vm.show4
                                  }
                                }
                              },
                              [_vm._v("Fixed price 1 year")]
                            ),
                            _vm._v(" "),
                            _c("transition", { attrs: { name: "fade" } }, [
                              _vm.show4
                                ? _c("div", { staticClass: "dropdown__el" }, [
                                    _c(
                                      "div",
                                      { staticClass: "dropdown-list" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "dropdown-item" },
                                          [_vm._v("Fixed price 6 months")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dropdown-item" },
                                          [_vm._v("Fixed price 6 months")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dropdown-item" },
                                          [_vm._v("Fixed price 6 months ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dropdown-item" },
                                          [_vm._v("Fixed price 6 months")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "dropdown-item" },
                                          [_vm._v("Fixed price 6 months")]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [_vm._v("Firstname")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", title: "Phone number" },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group error" }, [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../img/icon/exclamation-sign.svg"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" Lastname")
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", title: "Phone number" },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [_vm._v("E-mail")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", title: "Phone number" },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [_vm._v("Cellphone number")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", title: "Phone number" },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group textarea" }, [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [_vm._v("Your message")]
                          ),
                          _vm._v(" "),
                          _c("textarea", {
                            staticClass: "form-control",
                            attrs: { title: "Phone number" },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm._m(2)
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "contact__info" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _vm._m(8),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "faq__blck",
                          staticStyle: { display: "none" }
                        },
                        [
                          _vm._m(9),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "faq-list" },
                            _vm._l(_vm.faq, function(item, index) {
                              return _c(
                                "div",
                                {
                                  staticClass: "faq__item",
                                  class: { open: index === _vm.current_index }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-10",
                                        on: {
                                          click: function($event) {
                                            return _vm.openFaq(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "title" }, [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "min p-dgrey  mb-0"
                                            },
                                            [_vm._v(_vm._s(item.title))]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "transition",
                                          { attrs: { name: "fade" } },
                                          [
                                            index === _vm.current_index
                                              ? _c(
                                                  "div",
                                                  { staticClass: "content" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "min-min p-dgrey mb-0"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.content)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-2" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "icon",
                                          on: {
                                            click: function($event) {
                                              return _vm.openFaq(index)
                                            }
                                          }
                                        },
                                        [_c("span"), _vm._v(" "), _c("span")]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("faq-new", { attrs: { background: "bg-white" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-row" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("p", { staticClass: "p-title Raleway p-black" }, [
            _c("b", [_vm._v("Contact us")])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "Raleway min-med p-dgrey" }, [
            _vm._v(
              "On this page you can contact us with any questions you may have."
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "relawaySM med-max" }, [
        _c("img", { attrs: { src: "/img/icon/smile.svg", alt: "" } }),
        _vm._v("Do you have any question? Contact us!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btns" }, [
      _c("button", { staticClass: "btn btn-green btn-full" }, [
        _vm._v("contact us")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "relawaySM med-max" }, [
        _vm._v("Company information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name" }, [
      _c("p", { staticClass: "max-max p-blue" }, [
        _vm._v("TecknaSmart Sverige AB")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name" }, [
      _c("p", { staticClass: "min" }, [
        _c("b", [_vm._v("Org. Number:")]),
        _vm._v(" 559171-8522")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name" }, [
      _c("p", { staticClass: "min" }, [
        _c("b", [_vm._v("Epost")]),
        _vm._v(" "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("info@tecknael.se")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "address__info" }, [
      _c("p", { staticClass: "min" }, [_c("b", [_vm._v("Post adress:")])]),
      _vm._v(" "),
      _c("p", { staticClass: "min" }, [
        _vm._v(
          "TecknaSmart Sverige AB Kund-id WINXXXX, FE nr XXX 105 69 Stockholm"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "address__info" }, [
      _c("p", { staticClass: "min" }, [_c("b", [_vm._v("Visitor adress:")])]),
      _vm._v(" "),
      _c("p", { staticClass: "min" }, [
        _vm._v("TecknaSmart Sverige AB Markvardsgatan 15 113 54 Stockholm")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "Raleway med-max" }, [_c("b", [_vm._v("FAQ")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }